import "@/App.css";
import { BrowserRouter, Routes, Route, Navigate, useLocation } from "react-router-dom";
import { AuthProvider, useAuth } from "@/context/AuthContext";
import { LanguageProvider } from "@/context/LanguageContext";
import { ThemeProvider } from "@/context/ThemeContext";
import AuthCallback from "@/pages/AuthCallback";
import Landing from "@/pages/Landing";
import Login from "@/pages/Login";
import Dashboard from "@/pages/Dashboard";
import NewReport from "@/pages/NewReport";
import ReportView from "@/pages/ReportView";
import PublicReport from "@/pages/PublicReport";
import Blog from "@/pages/Blog";
import BlogPost from "@/pages/BlogPost";
import LegalPage from "@/pages/LegalPage";
import Admin from "@/pages/Admin";

const Loading = () => (
  <div className="min-h-screen flex items-center justify-center bg-background">
    <span className="font-mono text-sm text-muted-foreground animate-pulse">Yükleniyor…</span>
  </div>
);

const ProtectedRoute = ({ children, adminOnly = false }) => {
  const { user, loading } = useAuth();
  if (loading) return <Loading />;
  if (!user) return <Navigate to="/login" replace />;
  if (adminOnly && !user.is_admin) return <Navigate to="/dashboard" replace />;
  return children;
};

function AppRouter() {
  const location = useLocation();
  if (location.hash?.includes("session_id=")) {
    return <AuthCallback />;
  }
  return (
    <Routes>
      <Route path="/" element={<Landing />} />
      <Route path="/login" element={<Login />} />
      <Route path="/blog" element={<Blog />} />
      <Route path="/blog/:slug" element={<BlogPost />} />
      <Route path="/hakkimizda" element={<LegalPage page="hakkimizda" />} />
      <Route path="/iletisim" element={<LegalPage page="iletisim" />} />
      <Route path="/gizlilik" element={<LegalPage page="gizlilik" />} />
      <Route path="/kvkk" element={<LegalPage page="kvkk" />} />
      <Route path="/dashboard" element={<ProtectedRoute><Dashboard /></ProtectedRoute>} />
      <Route path="/yeni-rapor" element={<ProtectedRoute><NewReport /></ProtectedRoute>} />
      <Route path="/rapor/:id" element={<ProtectedRoute><ReportView /></ProtectedRoute>} />
      <Route path="/admin" element={<ProtectedRoute adminOnly><Admin /></ProtectedRoute>} />
      <Route path="/r/:id" element={<PublicReport />} />
      <Route path="*" element={<Navigate to="/" replace />} />
    </Routes>
  );
}

function App() {
  return (
    <div className="App">
      <BrowserRouter>
        <ThemeProvider>
          <LanguageProvider>
            <AuthProvider>
              <AppRouter />
            </AuthProvider>
          </LanguageProvider>
        </ThemeProvider>
      </BrowserRouter>
    </div>
  );
}

export default App;
